import { pendingLettersAtomFamily } from '@/atoms/letterAtoms';
import { activeSessionIdAtom } from '@/atoms/liveTranscriptionAtom';
import { useQuerySessionWindows } from '@/hooks/query/useQuerySessionWindows';
import {
  toWorkspaceArtifact as projectWorkspaceArtifact,
  useWorkspaceSnapshotCore,
  type ProjectWorkspaceSessionReader,
} from '@heidi/agents/data';
import { TabType } from '@heidi/session/contracts';
import { useQuerySessionById } from '@heidi/session/data';
import { useAtomValue } from 'jotai';
export const toWorkspaceArtifact = (
  artifact: Parameters<typeof projectWorkspaceArtifact>[0],
  activeTab: Parameters<typeof projectWorkspaceArtifact>[1],
  pendingLetters: Parameters<typeof projectWorkspaceArtifact>[3] = []
) => projectWorkspaceArtifact(artifact, activeTab, TabType.LETTER, pendingLetters);
const useSessionState: ProjectWorkspaceSessionReader = (
  openSessionId,
  subjectSessionId
) => {
  const pendingLetters = useAtomValue(pendingLettersAtomFamily(openSessionId ?? ''));
  const { data: windows } = useQuerySessionWindows({ sessionId: openSessionId ?? '' });
  const activeTab = windows.sessionWindows[windows.activeWindowIndex]?.activeTab;
  const { data: recordingMeta } = useQuerySessionById({
    sessionId: subjectSessionId ?? '',
    select: (session) => ({
      status: session?.recording_status ?? undefined,
      mode: session?.transcribe_mode ?? undefined,
    }),
  });
  return { activeTab, recordingMeta, pendingLetters };
};
export function useWorkspaceSnapshot() {
  return useWorkspaceSnapshotCore(
    useAtomValue(activeSessionIdAtom),
    useSessionState,
    TabType.LETTER
  );
}
